import React from "react";
import { Printer } from "lucide-react";

export const PrintButton = (): React.ReactElement => {
    return (
        <button
            onClick={() => window.print()}
            title="Print"
            className="print-none"
            style={{
                background: "inherit"
            }}
        >
            <Printer size={16} />
        </button>
    );
};
